module.exports = __webpack_public_path__ + "static/media/edit.539b3c38.svg";